import { ContentLayout } from 'components/layouts/ContentLayout';
import ganttStore from 'components/projectOverview/gantt/ganttConfig/ganttStore';
import { useParams } from 'react-router-dom';
import PlanningGantt from '../components/PlanningGantt';
import { PlanningGanttActionBar } from '../components/PlanningGanttActionBar';
import { useState } from 'react';

export const PlanningBoard = () => {
  const { projectId } = useParams();
  const [reloadGantt, setReloadGantt] = useState(false);
  const ganttId = `planning-gantt-${projectId}`;
  // ganttStore.createGantt(ganttId);

  const gantt = ganttStore.createGantt(ganttId);

  return (
    !gantt ? null : (<ContentLayout header={<PlanningGanttActionBar projectId={projectId} reloadGantt={reloadGantt} setReloadGantt={setReloadGantt} />} overflow={'hidden'}>
      <PlanningGantt ganttId={ganttId} projectId={projectId} reloadGantt={reloadGantt} />
    </ContentLayout>)
  );
};
